/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { WhatsAppAiReplyShowPathParams, WhatsAppAiReplyShowResponse } from '../types/WhatsAppAiReplyShow'

/**
 * GET /candidates/:candidateId/whatsapp-ai
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiReplyController.php WhatsAppAiReplyController::show
 */
export async function whatsAppAiReplyShow(
	candidateId: WhatsAppAiReplyShowPathParams['candidateId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppAiReplyShowResponse>> {
	return axiosInstance.get(`/candidates/${candidateId}/whatsapp-ai`, config)
}
